import { Grid } from "@mui/material";
import { TTProtectionNameForm } from "./TTProtectionNameForm";
import { TTProtectionDataForm } from "./TTProtectionDataForm";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";

export function TTProtectionForm({ disabledFields }: MdmFormProps) {
  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={12}>
        <TTProtectionNameForm disabledFields={disabledFields} />
      </Grid>
      <Grid item xs={12}>
        <TTProtectionDataForm disabledFields={disabledFields} />
      </Grid>
    </Grid>
  );
}
